define(function (require) {
    var $ = require("jquery");
    var Promise = require("bluebird");

    var exports = {};

	function localdebug(ajaxOptions)
	{
		if (!ajaxOptions.skipLocalDebug)
		{
			if (window.location.hostname == 'localhost') {
				console.log(ajaxOptions.method + " " + ajaxOptions.url, ajaxOptions.data);

			}
		}
	}


    exports.method = function (method, url, data, ajaxOptions) {
        if (ajaxOptions == null) {
            ajaxOptions = {};
        }

        ajaxOptions.method = method;
        ajaxOptions.url = url;

        //Si l'url est relative, on la rend absolu (alternative à l'iframe avec CORS)
        //if (ajaxOptions.url.startsWith("/")) {
        //    ajaxOptions.url = window.getBaseUrl() + ajaxOptions.url;
        //}

        if (data != null) {//optionnel
            ajaxOptions.data = data;
        }

        //option "cache" de $.ajax à false si non spécifié
        if (ajaxOptions.cache == null) {
            ajaxOptions.cache = false;
        }

		localdebug(ajaxOptions);

        //On conserve la référence xhr pour autoriser l'appellant à annuler la requete
        var xhr = $.ajax(ajaxOptions);

        var resultPromise = new Promise(function (resolve, reject) {
            xhr.done(function (data, textStatus, jqXHR) {
                if (data.Error != null && data.Error !== "") {
                    reject(new Error(data.Error)); //Le controlleur a répondu avec un champ error string non vide
                }
                else if (data.error != null && data.error !== "") {
                    reject(new Error(data.error)); //Le controlleur a répondu avec un champ error string non vide
                }
                else {
                    resolve(data);
                }
            }).fail(function (jqXHR, textStatus, errorThrown) {
                if (errorThrown === "") {
                    errorThrown = "La connexion au serveur a échoué."; //serveur down
                }

                //requete ajax annulée si errorThrown === "abort"
                
                //Reject si le controlleur send un objet avec une property "Error" non vide
                //On reject avec un objet du type Error afin de conserver le stack trace
                //Voir https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Error
                reject(new Error(errorThrown));

                /*
                 * L'url n'a pas été atteinte, erreurs courantes :
                 *  - Mauvaise url
                 *  - Le verbe utilisé n'est pas autorisée par l'action du controlleur (<AcceptVerbs(HttpVerbs.Get ...)>)
                 *  - Server is shutdown
                 */
            });
        });

        resultPromise.xhr = xhr;

        resultPromise.abort = function () {
            xhr.abort();
        }

        return resultPromise;
    }

    exports.get = function (url, data, ajaxOptions) {
        return this.method('GET', url, data, ajaxOptions);
    }

    exports.post = function (url, data, ajaxOptions) {
        return this.method('POST', url, data, ajaxOptions);
    }

    exports.delete = function (url, data, ajaxOptions) {
        return this.method('DELETE', url, data, ajaxOptions);
    }

    exports.put = function (url, data, ajaxOptions) {
        return this.method('PUT', url, data, ajaxOptions);
    }

    return exports;
});
